module.exports = __webpack_public_path__ + "static/media/2B.d7b7436d.png";